"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIconBubbleButton = exports.PaginationButtons = exports.StyledSelect = exports.PaginationSpacer = exports.PaginationControls = exports.ItemCount = exports.PageSize = exports.FooterItem = exports.TableFooter = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Select = _interopRequireDefault(require("../../../Inputs/Select/Select"));

var _IconBubbleButton = _interopRequireDefault(require("../../../Buttons/IconBubbleButton"));

var _DataGrid = require("../DataGrid.styles");

var _helperFunctions = require("../../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableFooter = _styledComponents.default.div.withConfig({
  displayName: "Footerstyles__TableFooter",
  componentId: "gr2tj8-0"
})(["display:flex;border-top:", ";justify-content:space-between;padding:0 ", ";"], _DataGrid.tableBorder, _DataGrid.tableGutter);

exports.TableFooter = TableFooter;

var FooterItem = _styledComponents.default.div.withConfig({
  displayName: "Footerstyles__FooterItem",
  componentId: "gr2tj8-1"
})(["flex:1;display:flex;align-items:center;"]);

exports.FooterItem = FooterItem;
var PageSize = (0, _styledComponents.default)(FooterItem).withConfig({
  displayName: "Footerstyles__PageSize",
  componentId: "gr2tj8-2"
})(["display:none;@media only screen and (min-width:", "){display:flex;}"], function (props) {
  return props.theme.smallBreak;
});
exports.PageSize = PageSize;
var ItemCount = (0, _styledComponents.default)(FooterItem).withConfig({
  displayName: "Footerstyles__ItemCount",
  componentId: "gr2tj8-3"
})(["justify-content:flex-start;@media only screen and (min-width:", "){justify-content:center;}"], function (props) {
  return props.theme.smallBreak;
});
exports.ItemCount = ItemCount;
var PaginationControls = (0, _styledComponents.default)(FooterItem).withConfig({
  displayName: "Footerstyles__PaginationControls",
  componentId: "gr2tj8-4"
})(["align-items:flex-end;flex-direction:column;padding-top:", ";@media only screen and (min-width:", "){justify-content:flex-end;flex-direction:row;padding-top:0;}"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 0.5, props.theme.standardPadding);
}, function (props) {
  return props.theme.smallBreak;
});
exports.PaginationControls = PaginationControls;

var PaginationSpacer = _styledComponents.default.div.withConfig({
  displayName: "Footerstyles__PaginationSpacer",
  componentId: "gr2tj8-5"
})(["display:flex;flex-direction:column;@media only screen and (min-width:", "){align-items:center;flex-direction:row;height:100%;}"], function (props) {
  return props.theme.smallBreak;
});

exports.PaginationSpacer = PaginationSpacer;
var StyledSelect = (0, _styledComponents.default)(_Select.default).withConfig({
  displayName: "Footerstyles__StyledSelect",
  componentId: "gr2tj8-6"
})(["width:4.5rem;"]);
exports.StyledSelect = StyledSelect;

var PaginationButtons = _styledComponents.default.div.withConfig({
  displayName: "Footerstyles__PaginationButtons",
  componentId: "gr2tj8-7"
})(["display:flex;justify-content:space-between;@media only screen and (min-width:", "){margin-left:1rem;}"], function (props) {
  return props.theme.smallBreak;
});

exports.PaginationButtons = PaginationButtons;
var StyledIconBubbleButton = (0, _styledComponents.default)(_IconBubbleButton.default).withConfig({
  displayName: "Footerstyles__StyledIconBubbleButton",
  componentId: "gr2tj8-8"
})(["@media only screen and (min-width:", "){margin-left:.5rem;}"], function (props) {
  return props.theme.smallBreak;
});
exports.StyledIconBubbleButton = StyledIconBubbleButton;